export const generateImageSrc = (src: string, width: number) => `${src}?w=${width * 2}`;
